export default __webpack_public_path__ + "static/media/weight-lifter.fdad7699.png";